import React, { useEffect } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { FiMail, FiMessageSquare, FiFileText, FiCode, FiSend } from 'react-icons/fi';

gsap.registerPlugin(ScrollTrigger);

const ProcessTimeline = () => {
    useEffect(() => {
        gsap.fromTo(".step-item",
            { opacity: 0, y: 30 },
            { opacity: 1, y: 0, duration: 0.8, stagger: 0.15, scrollTrigger: { trigger: ".process-container", start: "top 80%" } }
        );
    }, []);

    const steps = [
        { num: "01", icon: <FiMail />, title: "Contact Us", desc: "Reach out to us with your project details." },
        { num: "02", icon: <FiMessageSquare />, title: "Project Discussion", desc: "We discuss your goals and requirements." },
        { num: "03", icon: <FiFileText />, title: "Planning", desc: "We plan the best strategy for your project." },
        { num: "04", icon: <FiCode />, title: "Development", desc: "Our team brings your vision to life with precision." },
        { num: "05", icon: <FiSend />, title: "Launch", desc: "We launch, test and ensure everything works." },
    ];

    return (
        <section className="process-container py-24 px-6 max-w-7xl mx-auto">
            {/* Heading */}
            <div className="text-center mb-16">
                <h4 className="text-[#F2B135] font-bold tracking-widest uppercase text-sm mb-2">Our Process</h4>
                <h2 className="text-4xl md:text-5xl font-black text-white">Simple Process, Exceptional Results</h2>
            </div>

            {/* Steps Grid */}
            <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-8">
                {steps.map((step, index) => (
                    <div key={index} className="step-item flex flex-col items-center text-center group">

                        {/* Icon Box */}
                        <div className="w-20 h-20 bg-[#111] border border-white/10 rounded-full flex items-center justify-center text-[#F2B135] text-3xl mb-6 group-hover:border-[#F2B135] transition-all duration-500">
                            {step.icon}
                        </div>

                        {/* Step Number */}
                        <span className="text-[#F2B135] font-bold text-sm mb-2">{step.num}</span>

                        {/* Content */}
                        <h4 className="text-white font-bold text-lg mb-2">{step.title}</h4>
                        <p className="text-gray-400 text-sm leading-relaxed">{step.desc}</p>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default ProcessTimeline;